export default "__VITE_ASSET__pqEwfA5o__"